












import Vue from 'vue';
import { MStoreFormInput } from '@/components/shared';
import { WriteToConsoleTaskServiceSettingsModel } from '@/types';

export default Vue.extend({
  name: 'WriteToConsoleSettings',
  props: {
    settings: {
      type: Object as () => WriteToConsoleTaskServiceSettingsModel
    },
    isEditMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    message: {
      get(this: any) {
        return (this.settings as WriteToConsoleTaskServiceSettingsModel).message;
      },
      set(this: any, value: string) {
        this.$emit('update', { key: 'message', value });
      }
    }
  },
  components: { MStoreFormInput }
});
